import {EditTemplateDocument, EditTemplateInput} from "generated/graphql";
import {useMutation} from "@apollo/client";

export const useEditTemplate = () => {
  const [mutate] = useMutation(EditTemplateDocument);

  return (input: EditTemplateInput) => mutate({ variables: { input } });
}